import React from 'react'

import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg'

import Text from './Text'

const Header = ({
  title = 'Back',
  onPressLeftIcon = () => {},
  showProgressBar = false,
  progress = 1,
  totalProgress = 5,
}) => {
  return (
    <div className="bg-WHITE py-3 px-4 border-b border-solid border-b-border-secondary border-t-0 border-x-0 flex flex-col gap-4">
      <div className="flex flex-row items-center gap-1.5">
        <button onClick={onPressLeftIcon}>
          <ArrowLeft className="min-h-5.5 min-w-5.5" />
        </button>
        <Text
          tag={'p'}
          variant={'label'}
          size={'large'}
          className={'text-text-secondary'}
          textalign={'center'}
        >
          {title}
        </Text>
      </div>
      {showProgressBar && (
        <div className="overflow-hidden w-full h-1 relative bg-[#78788029] rounded-full">
          <div
            className="h-1 absolute z-10 left-0 top-0 bg-text-brand-tertiary rounded-full transition-all duration-500 ease-in-out"
            style={{ width: `${(progress / totalProgress) * 100}%` }}
          />
        </div>
      )}
    </div>
  )
}

export default Header
